import { Component, ViewChild, OnInit } from '@angular/core';
import { Nav, Platform, MenuController, Events } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { HomeComponent } from './modules/home/home.component';
import { AddResumeComponent } from './modules/authentication/components/add-resume/add-resume.component';
import { AuthenticationComponent } from './modules/authentication/authentication.component';
import { JobSearchComponent } from './modules/job-search/job-search.component';
import { TimelineComponent } from './modules/timeline/timeline.component';
import { SettingsService } from '../../../UI/src/app/shared/settings/settings.service';
import { AuthenticationService } from '../../../UI/src/app/shared/authentication/authentication.service';
import { SitemapService } from '../../../UI/src/app/shared/sitemap/sitemap.service';
import { TranslationLoaderService } from '../../../UI/src/app/shared/translation/translation-loader.service';
import { CandidateProfileComponent } from './modules/candidate-profile/candidate-profile.component';
import { SigninComponent } from './modules/authentication/components/signin/signin.component';
import { DocumentUploadComponent } from './modules/candidate-profile/document-upload/document-upload.component';
import { DocumentImportComponent } from './modules/candidate-profile/document-import/document-import.component';
import { JobAlertComponent } from './modules/job-alert/job-alert.component';
import { BrandingService } from '../../../UI/src/app/shared/branding/branding.service';
import { Storage } from '../../../UI/src/app/shared/constants'

@Component({
  templateUrl: 'app.html'
})
export class MyApp implements OnInit {
  @ViewChild(Nav) nav: Nav;

  //Assign the page that need to be opened when app was launched
  rootPage: any = HomeComponent;
  pages: any;
  private removeIndexes: any = [];
  private counter: number = 0;
  public loadCareers: boolean = false;
  public careerHomeUrl: string;
  private page = {
    '/location': HomeComponent,
    '/uploadresume': AuthenticationComponent,
    '/search': JobSearchComponent,
    '/timeline': TimelineComponent,
    '/candidate': CandidateProfileComponent,
    '/documents': DocumentUploadComponent
  };

  constructor(
    public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public menu: MenuController,
    private settings: SettingsService,
    public events: Events,
    private sitemapService: SitemapService,
    private authenticationservice: AuthenticationService,
    private translationLoader: TranslationLoaderService,
    private brandingService: BrandingService
  ) {
    this.initializeApp();
  }

  ngOnInit() {
    this.addClassElements();
    this.settings.GetAppSettings().subscribe(
      (response) => {
        this.loadTranslations();
        this.brandingService.setPWATheme();
        this.careerHomeUrl = window.localStorage.getItem(Storage.HOME_REDIRECT_URL);
        this.checkAndRedirectToHomeURL();
      },
      (error) => { this.loadTranslations(); }
    );
    this.settings.GetLoginSettings().subscribe(
      settings => {
      let geoMaps = settings.filter(setting => setting.key === "ELIXHRUI_GEOMAPS_APIKEY");
       if(geoMaps != null && geoMaps.length > 0 && geoMaps[0].value != "" && geoMaps[0].value != undefined) {
        this.settings.isGoogleAPIConfigured = true;
        const mapScript = document.createElement('script');
        mapScript.src = '//maps.googleapis.com/maps/api/js?key='+geoMaps[0].value +'&libraries=geometry';
        document.head.appendChild(mapScript);
       }
      });
  }

  private addClassElements() {
    const classes = ['donut-success','donut-danger','donut-info','donut-warning'];
    const parent = <HTMLDivElement>document.querySelector('ion-menu div');
    classes.forEach(e => {
      const ele = document.createElement('input');
      ele.className += e;
      parent.appendChild(ele);
    });
  }

  ionOpen() {
    let elm = <HTMLDivElement>document.querySelector('ion-menu div');
    if (elm) {
      elm.setAttribute('tabindex', '-1');
      elm.focus();
    }
  }

  private loadTranslations(): void {
    this.translationLoader.getTranslations(['TRANSLATIONS_CAREER_CORE'])
      .subscribe((response) => {
        this.events.publish('enableDisablePrivacyPolicyLink');
      });
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });

    this.events.subscribe('showSiteMapNodes', (data) => {
      this.handleEvents(data);
    });

    this.events.subscribe('showSiteMapNodesPublic', (data) => {
      this.handlePublicEvents(data);
    });
  }

  checkAndRedirectToHomeURL() {
    //navigate to Home URL automatically when the Home page is being loaded based on Home URL setting in Theme.
    if(this.careerHomeUrl && (location.href.split('#')[1] == undefined || location.href.split('/').pop() == 'home')) {
      window.location.href = this.careerHomeUrl;
      event.preventDefault();
    }
    else {
      this.loadCareers = true;
    }
  }

  handleEvents(data) {
    if (data) {
      this.sitemapService.getSitemapNodes()
        .subscribe(result => {
             this.pages = result;
             this.removeJobsNearMe();
        },
        error => {
          console.log(error);
        });
    }
  }

  handlePublicEvents(data) {
    if (data) {
      this.sitemapService.getPublicNodes()
        .subscribe(result => {
          this.pages = result;
          this.removeNodes(this.pages);
          this.removeJobsNearMe();
        },
        error => {
          console.log(error);
        });
      }
    }

  private removeNodes (data) {
    this.removeIndexes = [];
    this.counter = 0;
    data.forEach((element, index) => {
      if (element.nodeKey == "menu_rec_signin" || element.nodeKey == "menu_rec_getmatched") {
            this.removeIndexes.push(index);
          }
        });

        for (let i of this.removeIndexes) {
          this.pages.splice(i-this.counter, 1);
          this.counter++;
        }

        this.pages.forEach((element, index) => {
          if(element.nodeKey === 'menu_rec_home') {
            this.pages[index].OrdinalPosition = 1;
          }
          else if(element.nodeKey === 'menu_landing_rec_signin') {
            this.pages[index].OrdinalPosition = 2;
          }
          else if(element.nodeKey === 'menu_landing_rec_jobs_near_me') {
            this.pages[index].OrdinalPosition = 3;
          }
          else {
            this.pages[index].OrdinalPosition = 4;
          }
        });
      }

  openPage(page) {
    this.menu.close();
    this.authenticationservice.isAppliedwithLinkedIn = false;
    if (page.nodeKey === 'menu_rec_signout') {
      this.sitemapService.removeAuthToken();
      //Route to the external URL on click of Home Icon.
      if(this.careerHomeUrl) {
        window.location.href = this.careerHomeUrl;
        event.preventDefault();
      }
      else
        this.nav.setRoot(HomeComponent);
    }
    if (page.nodeKey === 'menu_rec_getmatched') {
      if (this.authenticationservice.isUserLoggedin()) {
        this.nav.setRoot(AddResumeComponent, true);
      } else {
        this.nav.setRoot(this.page[page.url.toLowerCase()]);
      }
    }
    else if (page.nodeKey === 'menu_landing_rec_signin') {
      this.nav.setRoot(SigninComponent, true);
    }
    else if (page.nodeKey === 'menu_landing_rec_jobs_alert') {
      this.nav.setRoot(JobAlertComponent, true);
    }
    else if (page.nodeKey === 'menu_landing_rec_jobs_near_me') {
      this.nav.setRoot(JobSearchComponent, {jobsNearMeClicked: true});
    }
    else if (page.nodeKey === 'menu_rec_home') {
      //Route to the external URL on click of Home Icon.
      if(this.careerHomeUrl) {
        window.location.href = this.careerHomeUrl;
        event.preventDefault();
      }
      this.nav.setRoot(HomeComponent, true);
    }
    else {
      this.nav.setRoot(this.page[page.url.toLowerCase()]);
    }
  }

  removeJobsNearMe() {
    this.pages.forEach((element, index) => {
     if(element.nodeKey === 'menu_landing_rec_jobs_near_me' && !this.settings.isGoogleAPIConfigured) {
        this.pages.splice(index, 1);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts